import articleApi from 'api/article';
import events from 'lib/events';
import Header from 'components/layout/header';
import hopscotch from 'hopscotch';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import SearchField from 'components/searchField';
import SearchResults from 'components/searchResults';
import session from 'services/sessionService';
import {countries, dealerAdminTourFormat} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import IntlWrapper from 'components/layout/intlWrapper';
import dealerApi from 'api/dealer';

let render = container => {
  console.info('[UI.page.support] rendering page');
  let {query, topic} = session.popSearch();

  ReactDOM.render(<IntlWrapper><WrappedSupportPage query={query}
                                                   topic={topic}/></IntlWrapper>, container);
  events.publish('page-change', {page: 'support'});
};

console.info('[UI.page.support] register route');
router.rr.add([{path: 'support', handler: routeUtils.requireAuth(render)}]);

// Page object
class SupportPage extends React.Component {
  static displayName = 'SupportPage';

  static initialState = {
    page: 1,
    query: '',
    results: {},
    submitted: false,
    topic: '',
    topics: [],
    dealer: {},
  };

  static propTypes = {
    topic: PropTypes.string,
    query: PropTypes.string,
  };

  state = SupportPage.initialState;

  componentWillMount() {
    events.subscribe('supportclear', () => {
      this.revertSearch();
    });
    if (this.props.topic) {
      this.state.topic = this.props.topic;
      this.setState({topic: this.props.topic});
    }
    if (this.props.query) {
      this.filterChange(this.props.query);
    }

    articleApi.getSupportTopics().then(topics => {
      this.setState({topics: topics});
    });

    dealerApi.getDealer(session.getUser().dealerId)
      .then(dealer => {
        this.setState({dealer});
      });
  }

  componentDidMount() {
    if (hopscotch.getState() === 'dealerAdmin:18') {
      hopscotch.startTour(dealerAdminTourFormat(this.props.intl.formatMessage), 18);
    }
  }

  componentWillUnmount() {
    if (hopscotch.isActive && window.location.hash !== '#tools') {
      hopscotch.endTour();
    }
  }

  onPageChange = page => {
    this.state.page = page;
    this.setState({page: page});
    this.performSearch();
  };

  getConfirmationMessage = () => {
    let {formatMessage} = this.props.intl;
    let message = formatMessage({id: 'support.confirmation.message.one'});

    if (this.state.view === 'software') {
      message = formatMessage({id: 'support.confirmation.message.two'});
    }

    return <div><p>{message}</p>
      <button className='btn btn-primary'
              onClick={this.resetPage}><FormattedMessage id="general.submit.another"/></button>
    </div>;
  };

  changeHandler = (property, after = null, valueProperty = 'value') => {
    return event => {
      this.state[property] = event.target[valueProperty];
      this.setState({
        [property]: event.target[valueProperty],
      });
      if (after) {
        after();
      }
    };
  };

  filterChange = term => {
    this.state.query = term;
    this.state.page = 1;
    this.setState({query: term, page: 1});
    this.performSearch();
  };

  navigateToArticle = slug => {
    window.location.hash = `support/${slug}`;
  };

  performSearch = () => {
    this.setState({results: null});
    articleApi.searchSupportArticles(this.state.query, this.state.topic, this.state.page).then(results => {
      this.setState({results: results});
    });

    events.publish('ga.event', {category: 'Search', action: 'sup-search-' + this.state.topic});
  };

  resetPage = () => {
    this.setState(SupportPage.initialState);
  };

  revertSearch = () => {
    this.setState({query: ''});
  };

  startTour = () => {
    window.location.hash = 'customers?tour';
  };


  topicChange = () => {
    this.state.page = 1;
    this.setState({page: 1});
    this.performSearch();
  };

  render() {
    let {formatMessage} = this.props.intl;
    let isSearching = this.state.query && this.state.query.length || this.state.topic;
    let searchResults = this.state.results;
    let permissionLevel = session.getUser() ? session.getUser().privileges.level : 1000;
    let {dealer} = this.state;
    //Based on permissionLevel, set different links for 'getting started'
    var gettingStartedLinks;

    if (permissionLevel === 1000) {
      gettingStartedLinks =
        <div>
          <a target='_new'
             onClick={() => this.navigateToArticle('water-test-video-draft')}><FormattedMessage id="support.link.running.test"/></a><br/>
          <a target='_new'
             onClick={() => this.navigateToArticle('test-printout-video-draft')}><FormattedMessage id="support.link.using.printouts"/></a><br/>
          <a target='_new'
             onClick={() => this.navigateToArticle('water-quality-score-video-draft')}>
            <FormattedMessage id="support.link.water.quality"/></a><br/>
        </div>;
    } else if (permissionLevel === 2000) {
      gettingStartedLinks =
        <div>
          <a target='_new'
             onClick={() => this.navigateToArticle('dashboard-video-draft')}><FormattedMessage id="support.link.using.dashboard"/></a><br/>
          <a target='_new'
             onClick={() => this.navigateToArticle('test-printout-video-draft')}><FormattedMessage id="support.link.using.printouts"/></a><br/>
          <a target='_new'
             onClick={() => this.navigateToArticle('reporting-video-draft')}><FormattedMessage id="support.link.reporting"/></a><br/>
        </div>;
    } else {
      gettingStartedLinks =
        <div>
          <a className='start-tour'
             target='_new'
             onClick={() => this.navigateToArticle('installation-upload-video-draft')}><FormattedMessage id="support.link.using.software"/></a><br/>
          <a className='start-tour'
             target='_new'
             onClick={() => this.navigateToArticle('preferences-video-draft')}><FormattedMessage id="support.link.setting.preferences"/></a><br/>
          <a className='start-tour'
             target='_new'
             onClick={() => this.navigateToArticle('user-set-up-video-draft')}><FormattedMessage id="support.link.managing.users"/></a><br/>
        </div>
      ;
    }
    return <div id='page-support'
                className='container'>
      <Header mainTitle={formatMessage({id: 'support.title'})}
              subTitle={isSearching ? formatMessage({id: 'general.search.results'}) : null}
              mainTitleReturn='support'
              intro={!isSearching ? formatMessage({id: 'support.description'}) : null}/>
      <div className='well clearfix'>
        <div className='col-sm-4'>
          <SearchField placeholder={formatMessage({id: 'general.search.articles.keyboards'})}
                       onSearch={this.filterChange}
                       initialValue={this.state.query}/>
        </div>
        <div className='col-sm-4'>
          <div className='form-group'>
            <select className='form-control'
                    value={this.state.topic}
                    onChange={this.changeHandler('topic', this.topicChange)}>
              <option value=''><FormattedMessage id="general.select.topic"/></option>
              {this.state.topics.map(topic => <option key={topic.ID}
                                                      value={topic.Name}>{topic.Name}</option>)}
            </select>
          </div>
        </div>
      </div>

      {!isSearching ?
        this.state.submitted ? this.getConfirmationMessage() :
        <div>
          <h2><FormattedMessage id="support.here.help"/></h2>

          <div className='row'>
            <div className='info-box col-sm-12 col-md-4'>
              <div className='col-sm-4 icon'>
                <i className='bl bl-power-circle'/>
              </div>
              <div className='col-sm-8 more-help'>
                <h6><FormattedMessage id="support.getting.started"/></h6>
                <a className='start-tour'
                     target='_new'
                     onClick={this.startTour}><FormattedMessage id="support.start.tour"/></a><br/>
                {gettingStartedLinks}
              </div>
            </div>
            <div className='info-box col-sm-12 col-md-3'>
              <div className='col-sm-4 col-md-5 icon'>
                <i className='bl bl-bioguard_technical_solutions'/>
              </div>
              <div className='col-sm-8 col-md-7'>
                <h6><FormattedMessage id="support.technical.solutions"/>:</h6>
                <p>1-800-859-7946</p>
              </div>
            </div>
            <div className='info-box col-sm-12 col-md-5'>
              <div className='col-sm-4 col-md-3 icon'>
                <i className='bl bl-helpful_links'/>
              </div>
              <div className='col-sm-8'>
                <h6><FormattedMessage id="support.helpful.links"/>:</h6>
                <div className='col-sm-6'
                       style={{padding: 0}}>
                  <a target='_new'
                       href={dealer.country === countries.CA ?
                         'http://www.bioguard.ca/' :
                         'http://www.bioguard.com/'}>BioGuard <FormattedMessage id="general.website"/></a><br/>
                  <a target='_new'
                       href={dealer.country === countries.CA ?
                         'http://www.spaguard.ca/' :
                         'http://www.spaguard.com/'}>SpaGuard <FormattedMessage id="general.website"/></a><br/>
                  {dealer.country === countries.US ?
                    <a target='_new'
                         href='http://www.proguardpools.com/'>ProGuard <FormattedMessage id="general.website"/></a> :
                      null}
                  <a target='_new'
                       href={dealer.country === countries.CA ?
                         'https://mybioguard.ca/customer/account/login/' :
                         'https://mybioguard.com/customer/account/login/'}><FormattedMessage id="general.my.bioguard"/></a>
                </div>
                <div className='link-container col-sm-6'>
                  <a target='_new'
                       href='https://kik-sds.thewercs.com/private/search.aspx?searchpage=NAPOOL&location=BIOGUARD%20EN_US'>
                      BioGuard/SpaGuard SDS
                  </a>
                  {dealer.country === countries.US ?
                    <a target='_new'
                         href='https://kik-sds.thewercs.com/private/search.aspx?searchpage=NAPOOL&location=PROGUARD%20EN_US'>ProGuard
                        SDS</a> :
                      null}
                </div>
              </div>
            </div>
          </div>
        </div> :
        <SearchResults {...searchResults} baseUrl='support/'
                       query={this.state.query}
                       onResultClick={article => this.navigateToArticle(article.slug)}
                       onPageChange={this.onPageChange}/>
      }
      <p>&nbsp;</p>
    </div>;
  }
}

let WrappedSupportPage = injectIntl(SupportPage);

export default WrappedSupportPage;
